import i18n from '@/i18n'

export function getTranslationOrUndefined (key) {
    const translated = i18n.t(key)

    if (translated === key) {
        return undefined
    } else {
        return translated
    }
}